import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

function Navbar({ onSidebarOpen }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setIsScrolled(currentScrollY > 50);
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <nav
      ref={navbarRef}
      className={`navbar-main ${isScrolled ? "scrolled" : ""} ${
        isVisible ? "visible" : "hidden"
      }`}
      aria-label="Main Navigation"
    >
      <div className="navbar-container">
        <div className="navbar-content">
          <Link className="navbar-brand" to="/" aria-label="Home">
            <img
              className="nav-logo"
              src="./images/logo.png"
              alt="BreakThrough Handyman Services Logo"
            />
            <span className="brand-title">BreakThrough Handyman</span>
          </Link>
          {onSidebarOpen && (
            <button
              className="mobile-menu-button"
              aria-label="Open navigation menu"
              onClick={onSidebarOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          )}
          <div className="navbar-menu">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/what-we-do">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  onClick={scrollToTop}
                  to="/guarantee"
                >
                  Guarantee
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/testimonials"
                  onClick={scrollToTop}
                  className="nav-link"
                >
                  Reviews
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
